module.exports = __webpack_public_path__ + "media/images/home/about_us/mes-b97303dd477d694c1bac7a910d5c733e.jpg";